import gql from 'graphql-tag';
import S3Object from './s3_object';

export default gql`
  fragment GroupSuggestion on GroupSuggestion {
    id
    title
    color
    icon_color
    icon
    color_map {
      hex
    }
    icon_color_map {
      hex
    }
    icon_map {
      bucket
      file_key
      width
      height
    }
    image {
      ...S3Object
    }
  }
  ${S3Object}
`;
